import { getEnvMode } from "./currentEnvMode.js";
const OssPath = {
  uat: "opyx-mtds-test.oss-cn-shenzhen-internal.aliyuncs.com",
  ver: "opyx-mtds-test.oss-cn-shenzhen-internal.aliyuncs.com",
  pro: "mtdsosscdn.oppein.com"
};
function getOssUrl(arg) {
  var _a, _b, _c;
  if (!arg.url)
    return "";
  const envMode = getEnvMode(arg.envMode);
  const ossPath = OssPath[envMode];
  const url = new URL(arg.url, `https://${ossPath}`);
  url.protocol = "https";
  url.host = ossPath;
  if (arg.compress) {
    const mode = ((_a = arg.compressParams) == null ? void 0 : _a.mode) || "m_lfit";
    const width = ((_b = arg.compressParams) == null ? void 0 : _b.width) || 100;
    const height = ((_c = arg.compressParams) == null ? void 0 : _c.height) || 100;
    url.searchParams.set("x-oss-process", `image/resize,${mode},h_${height},w_${width}`);
  }
  return url.toString();
}
export { getOssUrl };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getOssUrl.js